<HistoryUploadDetail headerTextOther="Other History Upload Details" detailsType="other" ListURL="Other/OtherHistoryUploadSearch">